import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;
  height: 100%;
  max-width: 700px;
  animation: ${appearFromLeft} 1.3s;

  div.box-container {
    max-width: 400px;
  }

  form {
    margin: 30px 0;
    max-width: 380px;

    h4 {
      color: ${({ theme }) => theme.colors.textPrimary};
    }

    h6 {
      color: ${({ theme }) => theme.colors.textSecondary};
    }

    a {
      color: ${({ theme }) => theme.colors.textPrimary};
      text-decoration: none;
      display: block;
      margin-top: 24px;
      transition: 0.5s color;

      &:hover {
        color: ${({ theme }) => shade(0.2, theme.colors.textPrimary)};
      }

      &.link-redirect {
        color: ${({ theme }) => theme.colors.secondary};

        &:hover {
          color: ${({ theme }) => shade(0.2, theme.colors.secondary)};
        }
      }
    }

    @media (max-width: 768px) {
      max-width: 340px;
    }
  }
`;

export const Background = styled.div`
  flex: 1;
  background: ${({ theme }) => theme.colors.secondary};
  background-size: cover;
`;

interface ItemValidationProps {
  check: boolean;
}

export const ValidationPassword = styled.li<ItemValidationProps>`
  background: ${({ check, theme }) =>
    !check ? theme.colors.tertiary : '#cff7ec'};
  padding: 0.2rem 0.5rem;
  border-radius: 1px;
  color: ${({ check }) => (!check ? '#9497a0' : '#3e8e6e')};
  font-size: 0.8rem;
  margin: 3px;
  position: relative;

  span {
    margin-left: 0.1rem;
  }

  svg {
    display: ${({ check }) => (!check ? 'none' : 'inline-block')};
    font-size: 1.1rem;
    position: absolute;
    right: -5px;
    top: -7px;
  }
`;
